// extracted by mini-css-extract-plugin
module.exports = {"flop":"PushYourLuck_flop__3BfS-","buttons":"PushYourLuck_buttons__1iq10","instructions":"PushYourLuck_instructions__1Ym-i"};